import React from 'react';
import { withRouter } from 'react-router-dom';

import NavBar from './NavBar';
import useContactDialog from './useContactDialog';

import { getTitleFromPath } from 'utils';

const API_VERSION = '/api/v1';
const HIDE_SHADOW = ['Orders'];
const SHOW_BACK = [
  'Users',
  'Order Form 1',
  'Order Strata Search',
  'Order Council Search',
  'Order Details',
  'Account',
  'Connections',
  'Searchlight'
];

export const NavBarContainer = ({
  user,
  history,
  onLogoutClick,
  notifications,
  location: { pathname }
}) => {
  const path = getTitleFromPath(pathname);

  const showBack = SHOW_BACK.includes(path);
  const apiRoute = pathname.includes(API_VERSION);
  const hideShadow = HIDE_SHADOW.includes(path);

  const handleNavigateConnections = () => history.push('/connections');

  const handleLogoutClick = () => onLogoutClick();

  const handleBackClick = () => {
    switch (path) {
      case 'Account':
      case 'Users':
      case 'Order Form 1':
      case 'Order Details':
      case 'Order Strata Search':
      case 'Order Council Search':
        return history.replace('/orders');
      default:
        return history.goBack();
    }
  };

  const [ renderContactDialog, toggleContactDialog ] = useContactDialog();

  const handleContactClick = () =>
    toggleContactDialog(true);

  if (apiRoute) return null;

  return (
    <React.Fragment>
      <NavBar
        user={user}
        title={path}
        showBack={showBack}
        hideShadow={hideShadow}
        onBackClick={handleBackClick}
        notifications={notifications}
        onLogoutClick={handleLogoutClick}
        onContactClick={handleContactClick}
        onConnectionsClick={handleNavigateConnections}
      />
      {renderContactDialog()}
    </React.Fragment>
  );
};

export default withRouter(NavBarContainer);
